var exports = {};
// eslint-disable-next-line es/no-typed-arrays -- safe
exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
export default exports;